import styled, { css } from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

import type { IPanelTheme } from "app/pages/sales-intelligence/common-components/collapsible-panel";
import { DEFAULT_COLLAPSIBLE_PANEL_THEME } from "app/pages/sales-intelligence/common-components/collapsible-panel";

const setVerticalContent = () => css`
    writing-mode: vertical-lr;
    transform: rotate(180deg);
`;

export const StyledTitle = styled.div`
    ${setVerticalContent()};

    margin-block: auto;
    margin-inline: 0;
    text-align: right;
    white-space: nowrap;
`;

export const StyledTitleWrap = styled.div`
    flex-grow: 1;
`;

export const StyledFiltersPanelCollapsedBar = styled(Stack).attrs<{ theme?: IPanelTheme }>((props) => ({
    ...props,
    theme: props.theme ?? DEFAULT_COLLAPSIBLE_PANEL_THEME,
}))`
    gap: 16px;
    height: 100%;
    padding: 8px;

    background: ${({ theme }) => theme.background};
    border-radius: 8px;
    box-sizing: border-box;

    cursor: default;

    ${({ onClick }) => {
        if (typeof onClick === "function") {
            return css`
                &:hover {
                    background: ${({ theme }) => theme.background};
                    cursor: pointer;
                }
            `;
        }
    }};
`;
